function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
const StyledButton = styled.button`
  label: JMT-General-BaseButton;
  padding: ${p => p.padding || '10px 15px'};
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  width: ${p => p.width || 'fit-content'};
  height: ${p => p.height || 'fit-content'};

  ${p => p.template}

  ${p => p.disabled ? css`
        opacity: 0.6;
        cursor: default;
      ` : ''}
  
  svg {
    margin-left: 10px;
  }
`;
export const BaseButton = React.forwardRef(({
  template,
  ...props
}, ref) => {
  return (// eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(StyledButton, _extends({}, props, {
      template: template,
      ref: ref
    }))
  );
});
BaseButton.propTypes = {
  template: PropTypes.shape()
};
BaseButton.defaultProps = {
  template: null
};